import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useKeyboardVisibility } from '@shared/hooks/use-keyboard-visibility.ts';
import { useAtomValue } from 'jotai/index';
import { navbarAtom } from '@app/atoms/app/navbar.atom.ts';
import { useCities } from '../../entites/city';
import { useRemoteStoreValidator } from '../../entites/app/use-remote-store-validator.tsx';
import { citiesAtom, cityAtom } from '@app/atoms/app/city.atom.ts';

export const MobileContent = () => {
  const { pathname } = useLocation();
  const isVisible = useKeyboardVisibility('visibility');
  const { type } = useAtomValue(navbarAtom);
  const cities = useAtomValue(citiesAtom);
  const selectedCity = useAtomValue(cityAtom);

  const bottomBarHiddenPages = ['/search', '/store', '/checkout'];

  const canHideBottomBar = isVisible
    ? true
    : !bottomBarHiddenPages.includes(pathname);

  useCities({ query: '' });
  useRemoteStoreValidator();

  const appBarHeight = type === 'none' ? '0px' : '64px';

  if (cities.length === 0) return null;
  if (!selectedCity.id && pathname !== '/initial') {
    return <Navigate to="/initial" />;
  }

  return (
    <div
      style={{
        height: canHideBottomBar
          ? 'calc(100dvh - 68px)'
          : `calc(100dvh - 65px - ${appBarHeight})`,
        paddingBottom: canHideBottomBar ? '68px' : '0px',
      }}
      className="px-4 lg:hidden container max-w-7xl overflow-y-scroll"
    >
      <Outlet />
    </div>
  );
};
